<mat-card>
  <mat-card-header>
    <mat-card-title>
      <span>{{ '+SRC_COMMISSIONINGV2.ADD_COMPONENT_HEADER' | translate }}</span>
      <button mat-icon-button (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content overflowShadow>
    <div class="content__body">
      <div class="content__img-section">
        <img
          class="flex-1"
          src="./assets/img/commissioningv2/device-black-{{
            (commissioningService.selectedDevice$ | async).icon
          }}.png"
          alt=""
        />
      </div>

      <div class="content__description-section">
        <div class="description-section__header">
          {{ '+SRC_COMMISSIONINGV2.ASSIGN_CHANNEL_SUBTITLE' | translate }}
        </div>

        <div class="content__channel-selection" #overflowShadowObservedElement>
          <ng-container [ngSwitch]="getAssignChannelDisplayState()">
            <ng-container *ngSwitchCase="AssignChannelDisplayState.AssignRooms">
              <ng-container *ngFor="let channel of channelsOptions">
                <span mat-select-top-label>{{ channel.title }}</span>
                <mat-form-field mat-select-height-small>
                  <mat-label>{{ '+SRC_COMMISSIONINGV2.SELECT_ROOM' | translate }}</mat-label>
                  <mat-select
                    [(value)]="channel.value"
                    (selectionChange)="onSelect($event.value, channel)"
                  >
                    <mat-select-trigger>
                      <span>
                        {{ channel.viewValue }}
                      </span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let room of roomsOptions" [value]="room.value">{{
                      room.viewValue
                    }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>
            </ng-container>

            <ng-container *ngSwitchCase="AssignChannelDisplayState.Loading">
              <app-banner type="info">
                {{ '+SRC_COMMISSIONINGV2.ASSIGN_CHANNEL_LOADING_CHANNELS' | translate }}
              </app-banner>
            </ng-container>
            <ng-container *ngSwitchCase="AssignChannelDisplayState.ErrorNoChannels">
              <app-banner type="warning">
                {{ '+SRC_COMMISSIONINGV2.ASSIGN_CHANNEL_NO_CHANNELS' | translate }}
              </app-banner>
            </ng-container>
            <ng-container *ngSwitchCase="AssignChannelDisplayState.ErrorNoRooms">
              <app-banner type="warning">
                {{ '+SRC_COMMISSIONINGV2.ASSIGN_CHANNEL_NO_ROOMS' | translate }}
              </app-banner>
            </ng-container>
            <ng-container *ngSwitchCase="AssignChannelDisplayState.Error">
              <app-banner type="error">
                {{ '+SRC_COMMISSIONINGV2.ASSIGN_CHANNEL_UNEXPECTED_ERROR' | translate }}
              </app-banner>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </mat-card-content>

  <mat-card-actions>
    <button
      gtm="onPreviousStep"
      gtmAction="Previous step"
      gtmCategory="assignChannelModal"
      mat-stroked-button
      color="primary"
      (click)="navigateBack()"
    >
      {{ 'GENERAL.BUTTON.BACK' | translate }}
    </button>
    <button
      gtm="onNextStep"
      gtmAction="Next step"
      gtmCategory="assignChannelModal"
      mat-raised-button
      color="primary"
      (click)="navigateForward()"
    >
      {{ 'GENERAL.BUTTON.CONFIRM' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
